import React from "react";
import ApplicationSetting from "@pages/ApplicationSetting";
import CashManagementSetting from "@pages/ApplicationSetting/CashManagementSetting";
import { MoneticValinaSetting } from "./ApplicationSettingMonetic/MoneticValinaSetting";

function Configuration({
    isConfigurationPrinterClicked,
    isConfigurationCashManagementClicked,
    rowData,
    setRowData,
    oneShop,
    setGlobalDataIsUpdated,
    isMoneticsPathsModalOpened,
    userID,
    shopId,
    franchiseID,
    appId,
    applicationChildrenId,
    setIsMoneticsPathsModalOpened,
    displayMode,
}: any) {
    return (
        <>
            {isConfigurationPrinterClicked && (
                <ApplicationSetting rowData={rowData} oneShop={oneShop} />
            )}

            {isConfigurationCashManagementClicked && (
                <CashManagementSetting
                    rowData={rowData}
                    setRowData={setRowData}
                    oneShop={oneShop}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                />
            )}

            {isMoneticsPathsModalOpened && (
                <MoneticValinaSetting
                    data={rowData}
                    infoData={{
                        userId: userID,
                        shopId: shopId,
                        franchiseId: franchiseID,
                        appId: appId,
                        appId_children: applicationChildrenId,
                    }}
                    setIsMoneticsPathsModalOpened={
                        setIsMoneticsPathsModalOpened
                    }
                    isMoneticsPathsModalOpened={isMoneticsPathsModalOpened}
                    setDataIsUpdated={setGlobalDataIsUpdated}
                    displayMode={displayMode}
                />
            )}
        </>
    );
}

export default Configuration;
